module.exports = __webpack_public_path__ + "img/United Overseas Bank.f57d2b2a.png";